// removed by extract-text-webpack-plugin
module.exports = {"container":"_38vsq","triangle":"_3i0IH"};


//////////////////
// WEBPACK FOOTER
// ./app/components/bordered-tooltip/bordered-tooltip.scss
// module id = 1071
// module chunks = 0 3 4 6